import React from 'react';
import { Filter, translate } from 'react-admin';

import SearchInput from './SearchInput';
import { TextInput } from 'react-admin';

const UnconnectedListFilter = ({ label, translate, ...props }) => (
	<Filter {...props}>
		<SearchInput
			source="q"
			label={label}
			alwaysOn
			autoFocus
			placeholder={translate('resources.general.fields.search')}
		/>
		<TextInput type="hidden" source="current_status" label={label} alwaysOn autoFocus />
	</Filter>
);

const ListFilter = translate(UnconnectedListFilter);

ListFilter.defaultProps = {
	label: 'resources.general.fields.search'
};

export default ListFilter;
